import providerTypeDetailTransformer from '../../transformers/providerTypeDetail';
import axios from 'axios';

export default (id) => {
  const promise = new Promise((resolve, reject) => {
    axios.get(process.env.VUE_APP_API_ADMIN_LOCATION + `providers/provider-types/${id}`).then(
      ({ data }) => {
        let dataRes = {};

        if (data.data) {
          dataRes = providerTypeDetailTransformer.fetch(data.data);
        }
        resolve(dataRes);
      },
      (error) => {
        reject(error);
      }
    );
  });

  return promise;
};
